import { screenSizeIsConsideredMobile, useScreenSize } from "@/lib/common/ScreenSizeContext";
import { type ViewType } from "@/lib/common/ViewType";
import { useUserPreferencesState } from "@/lib/state/UserPreferencesState";
import { useMemo } from "react";

export const usePreferredViewType = (): ViewType => {
	const { state } = useUserPreferencesState();
	const screenSize = useScreenSize();
	const preferredViewType = useMemo<ViewType>(() => {
		if (screenSizeIsConsideredMobile(screenSize)) {
			return "Gallery";
		}

		return state.viewTypePreference;
	}, [screenSize, state.viewTypePreference]);

	return preferredViewType;
};
